<template>
  <form novalidate class="md-layout py-3" :class="content.class_color" @submit.prevent="validateContact">
    <b-row v-if="success" class="mx-auto my-3">
      <p class="text-center mx-auto">{{ successMsg }}</p>
    </b-row>
    <md-field :class="getValidationClass('fullname')" class="form-mb-4">
      <label for="first-last-name">Nombres y apellidos</label>
      <md-input name="first-last-name" id="first-last-name" class="input-black" autocomplete="off"
                v-model="form.fullname" :disabled="sending"/>
      <span class="md-error" v-if="!$v.form.fullname.required">El nombre y apellido es requerido</span>
      <span class="md-error" v-else-if="!$v.form.fullname.minlength">Nombre y apellido inválido</span>
    </md-field>


    <md-field :class="getValidationClass('email')" class="form-mb-4">
      <label for="email">Correo electrónico</label>
      <md-input type="email" name="email" id="email" autocomplete="off" v-model="form.email"
                :disabled="sending"/>
      <span class="md-error" v-if="!$v.form.email.required">El Email es requerido</span>
      <span class="md-error" v-else-if="!$v.form.email.email">Email inválido</span>
    </md-field>

    <md-field :class="getValidationClass('message')" class="form-mb-4">
      <!-- <label for="message">Mensaje</label> -->
      <b-form-textarea
       id="message"
      v-model="form.message"
      rows="3"
      max-rows="6"
      placeholder="Mensaje"
      style="background-color: #EDEDED !important; box-shadow: none !important;
      padding-left: 1rem !important;"
      class="input-black textarea-suggestion" 
      autocomplete="off"
      name="message"
      :disabled="sending"
      ></b-form-textarea>
      <!-- <md-input name="message" id="message" class="input-black" autocomplete="off"
                v-model="form.message" :disabled="sending"/> -->
      <span class="md-error" v-if="!$v.form.message.required">El mensajes es requerido</span>
    </md-field>


    <div class="md-field formulario-center-button">
      <div id="formulario-boton">
        <button v-if="content.boton_img" type="submit" 
        :disabled="sending" class="button-primary-global">
                <span class="button-text-global">
                    {{ content.text_boton }}
                    <img src="@/assets/images/arrow_left.svg" alt="Left arrow img">
                </span>
        </button>
        <button v-else type="submit" :disabled="sending" class="button-primary-global">
          <span class="button-text-global-normal"> {{ content.text_boton }}</span>
        </button>
      </div>
    </div>
    <div class="md-field formulario-center-button" v-if="showDismissibleAlert">
      <div class="mt-1 pb-1">
        <b-alert style="text-align: center" id="alert-send"
                 v-model="showDismissibleAlert"  dismissible>
          <span> <strong>{{ lastUser }}</strong><br> Pronto le será agendada una cita!</span>
        </b-alert>
      </div>
    </div>
    <div class="md-field formulario-center-button" v-if="showDismissibleAlertError">
      <div class="mt-1 pb-1">
        <b-alert style="text-align: center" id="alert-send-ganger" variant="danger"
                 v-model="showDismissibleAlertError"  dismissible>
          <span> Intente mas tarde</span>
        </b-alert>
      </div>
    </div>
    <div class="vld-parent">
      <loading :active.sync="sending"
               :can-cancel="true"
               loader="dots"
               color="#FFC100"
               backgroundColor="black"
               :width=128
               :height=128
               :is-full-page="true">
      </loading>
    </div>
  </form>
</template>
<script>
  import { validationMixin } from 'vuelidate'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  import {
    required,
    email,
    minLength
  } from 'vuelidate/lib/validators'

  export default {
    name: 'formulario-2',
    mixins: [validationMixin],
    components: {Loading},
    props: {content: Object},
    data: () => ({
      form: {
        fullname: null,
        email: null,
        message: null
      },
      contactSaved: false,
      sending: false,
      lastUser: null,
      successMsg: '',
      success: false,
      showDismissibleAlert: false,
      showDismissibleAlertError: false
    }),
    validations: {
      form: {
        fullname: {
          required,
          minLength: minLength(3)
        },
        email: {
          required,
          email
        },
        message: {
          required,
          minLength: minLength(3)
        }
      }
    },
    methods: {
      getValidationClass (fieldName) {
        const field = this.$v.form[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      clearForm () {
        this.$v.$reset()
        this.form.fullname = null
        this.form.message = null
        this.form.email = null
      },
      saveSuggestion () {
        this.sending = true
        this.success = false
        this.$store.dispatch('postComment', this.form)
          .then(() => {
            window.setTimeout(()=> {
              this.sending = false
              this.success = true
              this.successMsg = 'Mensaje enviado éxitosamente'
              this.clearForm()
            }, 2000)
            window.setTimeout(()=> {
              this.sending = false
              this.success = false
              this.successMsg = 'Mensaje enviado éxitosamente'
              this.clearForm()
            }, 4000)
          })
          .catch((error) => {
            console.error('Error al enviar formulario:', error)
            console.error('Detalles del error:', {
              message: error.message,
              response: error.response,
              status: error.response?.status,
              data: error.response?.data
            })
            window.setTimeout(()=> {
              this.sending = false
              this.success = false
              this.successMsg = ''
              this.showDismissibleAlertError= true
            }, 2000)            
          })
        // this.$store.dispatch('registerContact', this.form)
        //   .then((response) => {
        //     console.log('response de registerContact:', response)
        //     this.showDismissibleAlert = true
        //     this.lastUser = `${this.form.name} ${this.form.phone}`
        //     this.contactSaved = true
        //     this.sending = false
        //     this.clearForm()
//            alert('Pronto sera atendido por uno de nuestros equipos GOX')
            /*revisar esto es para la barra de carga*/
//            window.setTimeout(() => {
//              this.lastUser = `${this.form.name} ${this.form.phone}`
//              this.contactSaved = true
//              this.sending = false
//              this.clearForm()
//            }, 1500)
          // })
          // .catch((error) => {
          //   this.sending = false
          //   this.showDismissibleAlertError= true
          //   console.log('error registerContact', error)
          // })
        // Instead of this timeout, here you can call your API

      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      validateContact () {
        this.$v.$touch()

        if (!this.$v.$invalid) {
          this.saveSuggestion()
        }
      },
      srcImagen(img) {
        let src = require('@/assets/images/' + img)
        return src
      },
      doAjax() {
        this.isLoading = true;
        // simulate AJAX
        setTimeout(() => {
          this.isLoading = false
        },5000)
      },
      onCancel() {
        // console.log('User cancelled the loader.')
      }
    }
  }
</script>
<style scoped>
</style>